/* eslint-disable import/no-anonymous-default-export */
import siteConfig, { formatMoney } from "../siteConfig";

export default {
  path: "/payments",
  shortTitle: "Payments",
  title: "Payment, pricing and fraud review",
  category: "Orders and legal",
  summary: `How ${siteConfig.currency} totals are formed, how hosted checkout works and why a return URL is not payment proof.`,
  updated: "26 October 2026",
  sections: [
    {
      heading: "Price and total",
      body: [
        `Catalog prices are displayed in ${siteConfig.currencyName} (${siteConfig.currency}). Checkout adds each line price multiplied by its quantity, then adds the fixed ${formatMoney(siteConfig.shippingFee)} delivery fee. No card field appears on the React page, and there is no coupon, gratuity, instalment or hidden handling line in the current calculation.`,
      ],
    },
    {
      heading: "Hosted payment hand-off",
      body: [
        `Pay Now generates a random reference. The same-site /create_payment.php bridge receives that reference together with the precise payable sum, ${siteConfig.currency} code, buyer email, selected destination country, first line's name and absolute success and cancellation addresses. Its job is to open the separate hosted session, where the delivery address and card credentials are collected.`,
        `A redirect to /payment?state=success means only that the browser returned by the success route. ${siteConfig.brandName} must independently verify the provider's server-side payment record before treating the order as paid. A cancellation route or closed browser does not by itself prove that no authorisation exists.`,
      ],
    },
    {
      heading: "Pricing errors and duplicate attempts",
      body: [
        "If the amount sent to the payment endpoint does not match the cart, the session should not be relied on. A clearly erroneous price may be corrected before order acceptance; a customer who does not accept the correction may cancel. Customers should avoid submitting repeatedly after an ambiguous result and instead send the order or payment reference for review.",
      ],
    },
    {
      heading: "Fraud and lawful review",
      body: [
        "Contact, destination, inventory and charge signals may be reviewed before acceptance. A transaction can be declined when payer authority cannot reasonably be established, law requires refusal, or fulfilment presents credible fraud or safety concerns. Screening may never be applied unlawfully or discriminatorily. If a declined request nevertheless produced a captured sum, repayment uses its incoming route, with account timing governed by the provider and the buyer's applicable protections preserved.",
      ],
    },
  ],
};
